<template lang="pug">
  .w-100.mh-100.h-100
    .d-flex.flex-wrap#axis-title(v-if="!reportData.IsSummary && reportData.Data.Data.PointsCount > 0")
      div(v-for="item in chartAxis", :key="item.name")
        b-form-checkbox.mr-2(v-model="item.selected", value="true", :style="{ color: item.color}") {{ item.text }}
      b-button.p-0(style="margin-left: auto;" variant="light", title="Перейти в сообщения по клику в графике", @click="messageActive = !messageActive")
        b-icon(:icon="messageActive ? 'envelope-fill' : 'envelope'", variant="dark")
    .d-flex(v-if="!reportData.IsSummary")
      .track_server-chart.row.no-gutters.w-100(v-if="reportData.Data.Data.PointsCount > 0")
        .track_chart.col(ref="chart-wrapper")
          D3#reportingSVGd3(v-if="widthSize" ref="d3", :params="paramsChart", :key="keySVG")
        b-table-simple.col-3(caption-top responsive small hover bordered no-border-collapse head-variant="light" selectable, select-mode="single", style="font-size: 12px; min-width: 280px;")
          b-tbody
            template(v-for="row in rowsSumTotal")
              b-tr(v-if="row.validate(reportData.Data.Data[row.key])" :key="row.key")
                b-td {{row.name}}
                b-td {{reportData.Data.Data[row.key]}} {{row.unit ? row.unit : ''}}
    div(v-if="(!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary.Rows).length > 0")
      .h6 Сливы/Заправки
      dx-data-grid(ref="grid"
      :data-source='!reportData.IsSummary ? reportData.Data.Data.Rows : reportSummary.Rows'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ 'max-height': '300px', width: localWidth }"
      :columns="!reportData.IsSummary ? fields.filter(f => f.dataField !== 'ObjectName') : fields"
      :row-alternation-enabled="true"
      :allow-column-reordering="true"
      :allow-column-dragging="false"
      @content-ready="onContentReady"
      @cell-click="onSelectionChanged")
        dx-scrolling(mode='virtual', :useNative="false")
        dx-sorting(mode="multiple")
        dx-load-panel(:enabled="true")
        dx-header-filter(:visible="true")
        dx-grouping(:auto-expand-all="reportData.IsSummary")
    div(v-if="(!reportData.IsSummary ? reportData.Data.Data.Totals : reportSummary.Totals).length > 0")
      .h6 Сводка
      dx-data-grid(ref="grid"
      :data-source='!reportData.IsSummary ? reportData.Data.Data.Totals : reportSummary.Totals'
      :selection="{ mode: 'single' }"
      :show-borders='true'
      :style="{ 'max-height': '300px', width: localWidth }"
      :columns="!reportData.IsSummary ? fieldsTotals.filter(f => f.dataField !== 'ObjectName') : fieldsTotals"
      :row-alternation-enabled="true"
      :allow-column-dragging="false"
      @content-ready="onContentReady")
        dx-scrolling(mode='virtual', :useNative="false")
        dx-load-panel(:enabled="true")
        dx-grouping(:auto-expand-all="reportData.IsSummary")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { DxDataGrid, DxScrolling, DxPaging, DxHeaderFilter, DxSorting, DxLoadPanel, DxGrouping } from 'devextreme-vue/data-grid';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.compact.css';
import dataGridReports from '@/mixins/dataGridReports';
import sizeProps from '@/mixins/sizeProps';
import D3 from '~/components/VueD3';
import imageGenerator from '~/plugins/handlers/imageGenerator';
import { SETTINGS_EVENTS } from '~/consts/eventTypes';

export default {
  name: 'FuelCAN',
  components: {
    D3,
    DxDataGrid,
    DxScrolling,
    DxPaging,
    DxHeaderFilter,
    DxSorting,
    DxLoadPanel,
    DxGrouping,
  },
  mixins: [dataGridReports, sizeProps],
  props: {
    reportData: {
      type: Object,
      default () {
        return {};
      },
    },
    track: {
      type: Object,
      default () {
        return {};
      },
    },
    colors: {
      type: Object,
      default () {
        return {};
      },
    },
  },
  data () {
    return {
      fields: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'RowNum',
        caption: '№',
        fixed: true,
        width: 50,
        alignment: 'right',
      }, {
        dataField: 'EventType',
        caption: 'Тип',
        alignment: 'center',
        width: 120,
      }, {
        dataField: 'Begin',
        caption: 'Начало',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'End',
        caption: 'Окончание',
        alignment: 'center',
        customizeText: params => new Date(params.value * 1000).toLocaleString('ru', { timeZone: 'UTC' }),
        width: 120,
      }, {
        dataField: 'Duration',
        caption: 'Длительность',
        alignment: 'center',
        width: 90,
      }, {
        dataField: 'Location',
        caption: 'Местоположение',
      }, {
        dataField: 'BeginValue',
        caption: 'Начальный уровень, л',
        alignment: 'right',
        width: 100,
      }, {
        dataField: 'EndValue',
        caption: 'Конечный уровень, л',
        alignment: 'right',
        width: 100,
      }, {
        dataField: 'Volume',
        caption: 'Разница, л',
        alignment: 'center',
        width: 100,
      }],
      fieldsTotals: [{
        dataField: 'ObjectName',
        caption: 'Объект',
        groupIndex: 0,
      }, {
        dataField: 'Date',
        caption: 'Дата',
        alignment: 'center',
        width: 90,
        customizeText: params => new Date(params.value * 1000).toLocaleDateString('ru', { timeZone: 'UTC' }),
      }, {
        dataField: 'RidesMileage',
        caption: 'Пробег в поездках, км',
        alignment: 'right',
      }, {
        dataField: 'MaxSpeed',
        caption: 'Максимальная скорость, км/ч',
        alignment: 'right',
      }, {
        dataField: 'RideTime',
        caption: 'Время в движении',
        alignment: 'center',
      }, {
        dataField: 'FuelSensorSum',
        caption: 'Потрачено по ДАРТ, л',
        alignment: 'right',
      }, {
        dataField: 'FuelSensorAvg',
        caption: 'Средний расход по ДАРТ, л/100 км',
        alignment: 'right',
      }, {
        dataField: 'BeginFuelLevel',
        caption: 'Начальный уровень топлива, л',
        alignment: 'right',
      }, {
        dataField: 'EndFuelLevel',
        caption: 'Конечный уровень топлива, л',
        alignment: 'right',
      }, {
        dataField: 'FillSum',
        caption: 'Заправлено, л',
        alignment: 'right',
      }, {
        dataField: 'FillCount',
        caption: 'Всего заправок',
        alignment: 'right',
      }, {
        dataField: 'DrainSum',
        caption: 'Слито, л',
        alignment: 'right',
      }, {
        dataField: 'DrainCount',
        caption: 'Всего сливов',
        alignment: 'right',
        width: 75,
      }, {
        dataField: 'EngineHoursText',
        caption: 'Моточасы',
        alignment: 'center',
      }],
      rowsSumTotal: [
        {
          key: 'FuelSensorSum',
          name: 'Потрачено по ДАРТ',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'FuelSensorAvg',
          name: 'Ср. расход по ДАРТ',
          unit: 'л/100 км',
          validate: value => true,
        }, {
          key: 'ParkingEngineHoursConsumption',
          name: 'Потрачено на холостом ходу',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'EngineHoursConsumption',
          name: 'Расход по моточасам',
          unit: ' л/ч',
          validate: value => true,
        }, {
          key: 'FillSum',
          name: 'Всего заправлено',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'FillCount',
          name: 'Всего заправок',
          validate: value => true,
        }, {
          key: 'DrainSum',
          name: 'Всего топлива слито',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'DrainCount',
          name: 'Всего сливов',
          validate: value => true,
        }, {
          key: 'MileageKm',
          name: 'Пробег',
          unit: 'км',
          validate: value => true,
        }, {
          key: 'EngineHoursText',
          name: 'Моточасы всего',
          validate: value => true,
        }, {
          key: 'ParkingEngineHoursText',
          name: 'Моточасы на холостом ходу',
          validate: value => true,
        }, {
          key: 'RideEngineHoursText',
          name: 'Моточасы в движении',
          validate: value => true,
        }, {
          key: 'BeginFuelLevel',
          name: 'Начальное значение топлива',
          unit: 'л',
          validate: value => true,
        }, {
          key: 'EndFuelLevel',
          name: 'Конечное значение топлива',
          unit: 'л',
          validate: value => true,
        },
      ],
      rowClick: null,
      chartAxis: [{
        text: 'Показание датчика топлива',
        name: 'Fuel',
        color: '#2578B2',
        selected: true,
        groupIndex: 0,
        z: 2,
      }, {
        text: 'ДАРТ',
        name: 'DartValue',
        color: '#E4E12E',
        selected: true,
        z: 1,
      }, {
        text: 'Скорость',
        name: 'Speed',
        color: '#32A034',
        selected: true,
        groupIndex: null,
        z: 3,
      }, {
        text: 'Моточасы',
        name: 'EngineHours',
        color: '#953754',
        selected: true,
        groupIndex: null,
        z: 6,
      }, {
        text: 'Пробег',
        name: 'Mileage',
        color: '#662178',
        selected: true,
        groupIndex: null,
        z: 7,
      }, {
        text: 'Напряжение',
        name: 'Voltage',
        color: '#FD7D26',
        selected: true,
        groupIndex: null,
        z: 5,
      }, {
        text: 'Зажигание',
        name: 'Ignition',
        color: '#9367BB',
        selected: true,
        groupIndex: null,
        z: 4,
      }],
      messageActive: false,
      keySVG: 'svgReporting',
      reportSummary: {
        Rows: [],
        Totals: [],
      },
      widthSize: null,
      loadingTrack: false,
    };
  },
  computed: {
    ...mapGetters('tracks', ['arrItems']),
    paramsChart () {
      if (this.reportData.IsSummary || !this.widthSize) {
        return {};
      }

      return {
        name: 'reportingChartControl',
        series: {
          id: this.reportData.id,
          axis: this.chartAxis,
        },
        loadDataUrl: '/Reporting/ChartPoints',
        getPointInfo: '/Reporting/PointInfo',
        selectRowTrack: this.selectRowReport,
        message: this.messageActive,
        drains: this.preparePoints(this.reportData.Data.Data.Rows.filter(x => x.EventType === 'слив')),
        fills: this.preparePoints(this.reportData.Data.Data.Rows.filter(x => x.EventType === 'заправка')),
        noinfo: this.preparePoints(this.reportData.Data.Data.RideDetectorEvents.filter(x => x.Name === 'нет информации')),
        rides: this.preparePoints(this.reportData.Data.Data.RideDetectorEvents.filter(x => x.Name === 'поездка')),
        width: this.widthSize - 20,
        height: 500,
        svgName: 'reportingSVG',
      };
    },
  },
  watch: {
    reportData (value) {
      this.rowClick = null;
      if (value.IsSummary) {
        this.convertSummaryData(value);
      }
      this.chartAxis.forEach((_c) => {
        const c = _c;
        c.selected = true;
      });
      this.updateSVG();
      this.getAddresses();
    },
    widthSize () {
      this.updateSVG();
    },
  },
  created () {
    loadMessages(ruMessages);
    locale('ru');
  },
  mounted () {
    if (this.reportData.IsSummary) {
      this.convertSummaryData(this.reportData);
    }
    this.getAddresses();
    this.updateChartWidth();
    this.$eventBus.subscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
      this.getAddresses,
    );
  },
  beforeDestroy () {
    this.$eventBus.unsubscribe(
      SETTINGS_EVENTS.addressSettingsChanged,
      // eslint-disable-next-line no-underscore-dangle
      this._name,
    );
  },
  updated () {
    this.updateChartWidth();
  },
  methods: {
    ...mapActions('tracks', ['getTrack']),
    preparePoints (points) {
      return points.map(x => ({ BeginDate: x.Begin * 1000, EndDate: x.End * 1000 }));
    },
    updateChartWidth () {
      if (this.$refs['chart-wrapper']) {
        const t = getComputedStyle(this.$refs['chart-wrapper']).width;
        const res = Math.floor(Number(t.substring(0, t.length - 2)));
        this.widthSize = res < 101 ? 101 : res;
      }
    },
    onSelectionChanged (item) {
      if (item.rowType === 'data') {
        if (this.reportData.BuildTrack && this.track.Id) {
          if (!(this.rowClick && this.rowClick.Begin === item.data.Begin && this.rowClick.End === item.data.End)) {
            const timeZone = Number(this.reportData.TimeZone.split(':', 3)[0]);
            const periods = [[new Date((item.data.Begin - timeZone * 3600) * 1000), new Date((item.data.End - timeZone * 3600) * 1000)]];
            this.$store.dispatch('tracks/updateTrack', { reportId: this.track.Id, secondColor: this.colors.alternative.hex, periods });
            this.reportData.periodsPartTrack = periods;
            this.rowClick = {
              Begin: item.data.Begin,
              End: item.data.End,
            };
          }
        }
        if (item.column.dataField === 'Begin' || item.column.dataField === 'End' || item.column.dataField === 'Location') {
          const value = {
            lat: item.data.LocationLatitude,
            lng: item.data.LocationLongitude,
          };
          this.$store.commit('map/setCenter', value);
          this.$store.commit('tracks/setActivePoint', [value.lat, value.lng]);
        }
      }
    },
    async selectRowReport (pointId) {
      if (this.loadingTrack) {
        return;
      }
      try {
        const track = this.arrItems.find(x => x.reportId === this.reportData.id);
        if (track) {
          this.$router.push('/tracks/');
          this.$nextTick(() => { this.$nuxt.$emit('focusTrackRow', track.id, pointId); });
        } else {
          const object = this.$store.state.objects.items[this.reportData.ObjectId];
          if (!object) {
            this.$store.dispatch('notify/addNotify', {
              massage: 'Ошибка: отсутствует объект из отчета, невозможно построить трек',
              type: 'danger',
            });
            return;
          }
          this.$router.push('/tracks/');
          this.loadingTrack = true;
          const { PeriodBegin, PeriodEnd } = this.reportData.Data;
          const from = new Date(PeriodBegin * 1000);
          const to = new Date(PeriodEnd * 1000);

          const params = {
            objectUid: object.data.UniqueId,
            objectId: object.id,
            from: new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, 0, 0, 0),
            to: new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, 0, 0, 0),
            color: this.colors.color.hex,
            useRideDetector: true,
            rebuildOnFailures: false,
            name: object.data.Name,
            image: await this.imGen(object.data.Icon),
            timeZone: (from.getTimezoneOffset()) / (-60),
          };
          this.getTrack({
            params,
            after: (v) => {
              this.$store.state.tracks.items[v[1]].reportId = this.reportData.id;
              this.$nuxt.$emit('focusTrackRow', v[0], pointId);
              this.loadingTrack = false;
            },
          });
        }
      } catch (e) {
        console.error(e);
        this.loadingTrack = false;
      }
    },
    async imGen (_icon) {
      const file = `${process.env.API_ADDRESS}/v1/GetIconImage(Id='${_icon.IconFile}')`;
      const image = await imageGenerator({
        file,
        size: _icon.Size,
        offset: [_icon.X, _icon.Y],
      });
      return image;
    },
    updateSVG () {
      this.keySVG = this.keySVG === 'svgReporting' ? 'reloadReportingSVG' : 'svgReporting';
    },

    convertSummaryData (data) {
      const rows = [];
      const totals = [];
      data.Data.Data.forEach((items) => {
        items.Rows?.forEach((_row, i) => {
          const row = _row;
          row.RowNum = i + 1;
          row.ObjectName = items.ObjectName;
          rows.push(row);
        });
        items.Totals?.forEach((_row, i) => {
          const row = _row;
          row.ObjectName = items.ObjectName;
          totals.push(row);
        });
      });
      this.reportSummary.Rows = rows;
      this.reportSummary.Totals = totals;
    },

    getAddresses () {
      if (this.reportData.State === 'Done' || this.reportData.State === 'OK') {
        if (!this.reportData.IsSummary) {
          this.reportData.Data.Data.Rows.forEach((row) => {
            this.getAddress(row.LocationLatitude, row.LocationLongitude, row);
          });
        } else {
          this.reportData.Data.Data.forEach((obj) => {
            obj.Rows.forEach((row) => {
              this.getAddress(row.LocationLatitude, row.LocationLongitude, row);
            });
          });
        }
      }
    },
    getAddress (lat, lon, _row) {
      const row = _row;
      row.Location = null;
      setImmediate(async () => {
        row.Location = await this.$store.dispatch('nominatim/getAddress', { lat, lon });
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
  .track_server-chart {
    display: flex;
    height: 100%;
  }
</style>
